import type { ReactNode } from "react";

import { DocumentShippableEntityPreviewEditor } from "~/components/domain/orders/DocumentShippableEntityPreviewEditor";
import { DocumentAddressSourceSelect } from "~/modules/orders/order-menu-document-extensions/DocumentAddressSourceSelect";
import type { OrderDocumentAddressCandidate } from "~/shared/documents/order-document-source";
import { Paper, Stack } from "~/ui";
import type { DocumentShippableEntity } from "~/utils/address-formatters";

type Props = {
  label: string;
  value?: DocumentShippableEntity;
  onChange: (value: DocumentShippableEntity) => void;
  withAsterisk?: boolean;
  error?: ReactNode;
  sourceLabel?: string;
  preferredCandidateId?: string;
  candidates?: readonly OrderDocumentAddressCandidate[];
};

export const DocumentAddressOverrideEditor = ({
  label,
  value,
  onChange,
  withAsterisk,
  error,
  sourceLabel,
  preferredCandidateId,
  candidates = [],
}: Props) => (
  <Paper withBorder radius="sm" p="sm">
    <Stack spacing="xs">
      {sourceLabel && (
        <DocumentAddressSourceSelect
          label={sourceLabel}
          candidates={candidates}
          value={value}
          preferredCandidateId={preferredCandidateId}
          onChange={onChange}
        />
      )}
      <DocumentShippableEntityPreviewEditor
        label={label}
        value={value ?? null}
        onChange={onChange}
        withAsterisk={withAsterisk}
        error={error}
      />
    </Stack>
  </Paper>
);
